import { baseApi } from '@/lib/rtkQuery/baseApi';

import {
	FetchTrialSiteManagementPatientsRequest,
	FetchTrialSiteManagementPatientsResponse,
	FetchTrialSiteManagementPatientDetailsRequest,
	FetchTrialSiteManagementPatientDetailsResponse,
	FetchTrialSiteManagementStatsRequest,
	FetchTrialSiteManagementStatsResponse,
	RandomisePatientRequest,
} from '../types';

export const trialSiteManagementApi = baseApi
	.enhanceEndpoints({
		addTagTypes: ['patient_list', 'pateint_tsm_details', 'tsm_stats'],
	})
	.injectEndpoints({
		endpoints: (build) => ({
			fetchTrialSiteManagementStats: build.query<
				FetchTrialSiteManagementStatsResponse,
				FetchTrialSiteManagementStatsRequest
			>({
				query: ({ study_site_id, study_id }) => {
					return {
						url: `/v1/study-site/${study_site_id}/study/${study_id}/stats/`,
						method: 'GET',
					};
				},
				providesTags: ['tsm_stats'],
			}),
			fetchTrialSiteManagementPatients: build.query<
				FetchTrialSiteManagementPatientsResponse,
				FetchTrialSiteManagementPatientsRequest
			>({
				query: ({ page, page_size, ordering, search_value, study_id, study_site_id }) => {
					return {
						url: `/v1/study-site/${study_site_id}/study/${study_id}/patient/?page=${page}&page_size=${page_size}&search=${search_value}&ordering=${ordering}`,
						method: 'GET',
					};
				},
				providesTags: ['patient_list'],
			}),
			fetchTrialSiteManagementPatientDetails: build.query<
				FetchTrialSiteManagementPatientDetailsResponse,
				FetchTrialSiteManagementPatientDetailsRequest
			>({
				query: ({ study_site_id, study_id, patient_identifier }) => {
					return {
						url: `/v1/study-site/${study_site_id}/study/${study_id}/patient/${patient_identifier}/`,
						method: 'GET',
					};
				},
				providesTags: ['pateint_tsm_details'],
			}),
			randomisePatient: build.mutation<void, RandomisePatientRequest>({
				query: ({ patient_identifier }) => {
					return {
						url: `v1/flusniff/patient/${patient_identifier}/randomise/`,
						method: 'POST',
					};
				},
				invalidatesTags: ['pateint_tsm_details'],
			}),
		}),
	});

export const {
	useFetchTrialSiteManagementStatsQuery,
	useFetchTrialSiteManagementPatientsQuery,
	useFetchTrialSiteManagementPatientDetailsQuery,
	useRandomisePatientMutation,
} = trialSiteManagementApi;
